$(function () {

  /* show/hide insert image(s) buttons */
  $(document.body).on('change', '.col-checkbox input[type=checkbox]', function () {
    var $checkboxes = $('tbody .col-checkbox input[type=checkbox]'),
        checked_checkboxes_length = $checkboxes.filter(':checked').length;

    if (checked_checkboxes_length > 1) {
      $('.btn[data-insert-text-variable]').hide();
      $('.btn[data-insert-text-variables]').show();
    } else if (checked_checkboxes_length == 1) {
      $('.btn[data-insert-text-variable]').show().removeAttr('disabled');
      $('.btn[data-insert-text-variables]').hide();
    } else {
      $('.btn[data-insert-text-variable]').show().attr('disabled', true);
      $('.btn[data-insert-text-variables]').hide();
    }
  });

  /* handle insert text variable(s) submit */
  $('.modal-footer .btn-dark').on('click', function () {
    var $checkboxes = $('tbody .col-checkbox input[type=checkbox]').filter(':checked'),
        textVariables = '';
    
    $checkboxes.each(function () {
      var $this = $(this);
      textVariables = textVariables + $this.data('key');
    });

    window.parent._insertTextVariables(textVariables);
    window.parent.hide_modal();
  });

});